import API from "Services/Api";

// Correção 2026-08-24: essa chamada é pro colabi-api (rota real
// appointments/cancel/{id}, protegida por jwt.verify), não pro
// labiexames-wp. A instância axios anterior configurava baseURL do WP, mas
// como a URL passada pro .post() já era absoluta (REACT_APP_API_URL), o
// axios ignorava esse baseURL — código morto que nunca chamou o WP de
// verdade. Usando a instância compartilhada (cookie httpOnly via
// withCredentials), igual aos demais Requests que falam com o Colabi.
export const cancelAppointment = async (id: number) => {

  try {
    const data = await API.post(
      `/appointments/cancel/${id}`,
      {
        noEmail: true,
        noShow: true
      }
    )

    return { data }
  } catch (error: any) {
    console.error(error)
  }
}